import React, { useState, useEffect, lazy, Suspense } from "react";
import Navbar from "./components/Navbar";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import ReactDOM from "react-dom";

// Lazy load your page components
const Home = lazy(() => import("./components/Home/Home"));
const About = lazy(() => import("./components/About/About"));
const Projects = lazy(() => import("./components/Projects/Projects"));
const PhD = lazy(() => import("./components/PhD/PhD"));
const Teaching = lazy(() => import("./components/Teaching/Teaching"));
const Resume = lazy(() => import("./components/Resume/ResumeNew"));
const Research = lazy(() => import("./components/Research/Research"));

function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div style={{ textAlign: "center" }} id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/phd" element={<PhD />} />
            <Route path="/teaching" element={<Teaching />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/research" element={<Research />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}
const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

export default App;
